import "pace-js";

window.paceOptions = { startOnPageLoad: false };

window.Pace.start();
